module.exports = __webpack_public_path__ + "mobile.76aa9e45.webp";